import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import reducerGenerator from '../../comments/reducerGenerator'
import taskPanelReducerGenerator from '../reducerGenerator'
import assignmentsReducerGenerator from '../../usersAssignedToHierarchy/reducerGenerator'
import {ReportedTimeSortConstants} from '../constants'

const createEditTaskPanelReducer = (initAppData) => {
    const commentsReducer = reducerGenerator({
        actionTypes: ActionTypes,
        initAppData: {
            ...initAppData,
            newCommentsTexts: initAppData.COMMENTS.TASK_NEW_COMMENTS
        }
    })

    const panelReducer = taskPanelReducerGenerator({
        actionTypes: ActionTypes,
    })

    const assignmentsReducer = assignmentsReducerGenerator({
        actionTypes: {
            ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
            ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
            CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET,
            CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET,
        }
    })

    const initialState = {
        ...commentsReducer.initialState,
        ...panelReducer.initialState,
        ...assignmentsReducer.initialState,

        openTaskId: null,
        openedFromUrl: false,
        canEdit: false,
        updatingState: {
            name: false,
            deadline: false,
            typeOfWork: false,
            estimate: false,
            description: false,
            moveToDialog: false,
        },
        taskDetails: {
            blockedDueToLockedTime: false,
            blockedDueToUnavailableToModifyTimeTrack: false,
            taskHasOtherUsersTimeTrack: false,
            taskHasManagerTimeTrack: false,
            taskHasOtherUsersApprovedTimeTrack: false,
            taskHasManagerApprovedTimeTrack: false,
            hasManagerApprover: false,
            canManageAllUsersWithoutAutoApproved: false,
        },
        taskDeletedSuccessfully: false,
        taskDeletedUnsuccessfully: false,

        auditInfo: {
            lastAuditActions: {
                createAction: null,
                updateAction: null,
            },
            allAuditHistoryLoaded: false,
            auditHistoryLoading: false,
            auditActions: [],
        },

        executorsSummary: {
            total: null,
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0,
        },
        reportedTimeComments: [],
        allTimeCommentsLoaded: false,
        timeAndCommentsLoading: false,
        sortingSettings: {
            sortBy: ReportedTimeSortConstants.BY_DATE,
            sortOrder: ReportedTimeSortConstants.DESC,
        },
        customFieldsValues: {}
    }

    return handleActions({
        ...commentsReducer.handlers,
        ...panelReducer.handlers,
        ...assignmentsReducer.handlers,

        [ActionTypes.OPEN_TASK_SET]: (state, {payload: openTaskId}) => ({...state, openTaskId}),
        [ActionTypes.TASK_PANEL_UPDATING_STATE_SET]: (state, {payload: changedData}) => ({
            ...state,
            updatingState: {...state.updatingState, ...changedData}
        }),
        [ActionTypes.TASK_PANEL_EDITABLE_SET]: (state, {payload: canEdit}) => ({...state, canEdit}),
        [ActionTypes.TASK_PANEL_OPENED_FROM_URL_SET]: (state, {payload: openedFromUrl}) => ({...state, openedFromUrl}),
        [ActionTypes.TASK_DETAILS_SET]: (state, {payload: taskDetails}) => ({...state, taskDetails}),

        [ActionTypes.TASK_EXECUTORS_SUMMARY_SET]: (state, {payload: executorsSummary}) => ({...state, executorsSummary}),
        [ActionTypes.ALL_TIME_COMMENTS_LOADED_SET]: (state, {payload: allTimeCommentsLoaded}) => ({...state, allTimeCommentsLoaded}),
        [ActionTypes.TIME_AND_COMMENTS_LOADING_SET]: (state, {payload: timeAndCommentsLoading}) => ({...state, timeAndCommentsLoading}),
        [ActionTypes.REPORTED_TIME_COMMENTS_SET]: (state, {payload: reportedTimeComments}) => ({...state, reportedTimeComments}),
        [ActionTypes.REPORTED_TIME_COMMENTS_ADD]: (state, {payload: reportedTimeComments}) => ({
            ...state,
            reportedTimeComments: [...state.reportedTimeComments, ...reportedTimeComments],
        }),
        [ActionTypes.SORTING_SETTINGS_SET]: (state, {payload: sortingSettings}) => ({...state, sortingSettings}),

        [ActionTypes.TASK_DELETED_SUCCESSFULLY_SET]: (state) => ({...state, taskDeletedSuccessfully: true}),
        [ActionTypes.TASK_DELETED_UNSUCCESSFULLY_SET]: (state) => ({...state, taskDeletedUnsuccessfully: true}),
        [ActionTypes.TASK_DELETION_STATUS_RESET]: (state) => ({
            ...state,
            taskDeletedSuccessfully: false,
            taskDeletedUnsuccessfully: false,
        }),

        [ActionTypes.TASK_AUDIT_HISTORY_INFO_SET]: (state, {payload: changedData}) => ({
            ...state,
            auditInfo: {...state.auditInfo, ...changedData}
        }),
        [ActionTypes.AUDIT_HISTORY_ADD]: (state, {payload: newItems}) => ({
            ...state,
            auditInfo: {
                ...state.auditInfo,
                auditActions: state.auditInfo.auditActions.concat(newItems)
            }
        }),
        [ActionTypes.AUDIT_HISTORY_SET]: (state, {payload: auditActions}) => ({
            ...state,
            auditInfo: {
                ...state.auditInfo,
                auditActions
            }
        }),
        [ActionTypes.TASK_PANEL_STATE_RESET]: (state) => ({
            ...state,
            auditInfo: initialState.auditInfo,
        }),
        [ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE]: (state, {payload: customFieldsValues}) => ({
            ...state,
            customFieldsValues: {
                ...state.customFieldsValues,
                ...customFieldsValues,
            },
        }),
        [ActionTypes.CUSTOM_FIELDS_VALUES_SET]: (state, {payload: customFieldsValues}) => ({
            ...state,
            customFieldsValues,
        }),
    }, initialState)
}

export default createEditTaskPanelReducer


// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/reducer.js